// https://ryanmulligan.dev/blog/sticky-header-scroll-shadow/

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".js-sticky-header");
  if (!header) return;
  const intercept = document.createElement("div");

  // Add an attribute to the intercept element to identify it in the devtools
  intercept.setAttribute("data-observer-intercept", "");
  header.before(intercept);

  const observer = new IntersectionObserver(([entry]) => {
    header.classList.toggle("sticky-header--active", !entry.isIntersecting);
  });

  observer.observe(intercept);
});
